<template>
  <div class="hf-form-ui-form">

    <el-dialog
        :visible.sync="dialogVisible"
        v-bind:title="title"
        width="80%"
        :before-close="handleClose">

      <FormUiForm v-if="loadSuccess"
                  ref="FormUiFormRef"
                  v-bind:removeFileds="removeFields"
                  v-bind:ruleFormSrc="ruleForm"
                  v-bind:autoSubmit="autoSubmit"
                  v-bind:beanName="simpleFormResp.beanName"
                  v-on:submitForm="submitFormObj">
      </FormUiForm>
    </el-dialog>
  </div>
</template>
<script>
import FormUiForm from './FormUiForm.vue'
import formuiService from './service/formui/FormuiService'
import httpUtil from './service/base/httpUtil'
import formuiConfig from './formuiConfig.js'

export default {
  components:{FormUiForm},
  props: {
    simpleFormName: String,
    id: String,
    formData: Object,   //用于编辑的编辑格式
    title: String,
    autoSubmit: Boolean,
    tableName: String,
    runType: String
  },
  data() {
    return {
      dialogVisible:true,
      loadSuccess: false,
      ruleForm: {},
      simpleFormResp: {},
      removeFields: '',
      queryParams:{}
    }
  },
  created() {
    // alert(1)
    this.simpleFormPath = formuiConfig.simpleFormPath
  },
  mounted() {
    // alert(2)
    Object.keys(this.$route.query).forEach(key => {
      this.queryParams[key] = this.$route.query[key]
    })

    this.loadData()
  },
  beforeDestroy() {
    console.log('----onBeforeUnmount-tableformDialog----')
    this.loadSuccess = false
  },
  methods: {
    submitFormObj(formObj) {
    let that=this
      formObj.fuTableName = this.tableName
      if (this.simpleFormResp.method === 'POST') {
        httpUtil.httpPost(that, '/formui/table/process_simple_table_form', formObj, (res) => {
          if (res.status.code !== 1) {
            alert(res.status.msg) // 修改: ElMessage 改为 alert
          } else {
            that.$emit('submitCallback', res)
            that.$emit('closeDialog')
            alert('提交完成.') // 修改: ElMessage 改为 alert
          }
        }, (err) => {
          console.error('err post' + err)
          alert('提交错误，需要调试.') // 修改: ElMessage 改为 alert
        })
      } else if (this.simpleFormResp.method === 'GET') {
        console.log('暂不支持get')
      } else if (this.simpleFormResp.method === 'PUT') {
        httpUtil.httpPut(that,  '/formui/table/process_simple_table_form', formObj, (res) => {
          if (res.status.code !== 1) {
            alert(res.status.msg) // 修改: ElMessage 改为 alert
          } else {
            that.$emit('submitCallback', res)
            that.$emit('closeDialog')
            alert('提交完成.') // 修改: ElMessage 改为 alert
          }
        }, (err) => {
          console.error('err put' + err)
          alert('提交错误，需要调试.') // 修改: ElMessage 改为 alert
        })
      } else if (this.simpleFormResp.method === 'DELETE') {
        httpUtil.httpDelete(that, '/formui/table/process_simple_table_form', formObj, (res) => {
          that.$emit('submitCallback', res)
          that.$emit('closeDialog')
          alert('删除完成.') // 修改: ElMessage 改为 alert
        }, (err) => {
          console.error('err post' + err)
          alert('删除错误，需要调试.') // 修改: ElMessage 改为 alert
        })
      }
    },
    handleClose(done) {
      done()
      this.$emit('closeDialog')
      console.log('closeDialog---from dialog')
    },
    loadData() {
      let param = { 'tableName': this.tableName, 'runType': this.runType }
      if (this.runType === 'EDIT') {
        param['id'] = this.formData['id']
      }
      if (this.runType === 'DELETE') {
        param['id'] = this.formData['id']
      }
      formuiService.getTableSimpleForm(this,param, (resp) => {
        this.simpleFormResp = resp
        this.removeFields = resp.removeFields.split(',')
        if (this.autoSubmit === true) {
          this.ruleForm['id'] = resp.dataObj['id']
          this.submitFormObj(this.ruleForm)
          return
        }
        if (resp.dataObj) {
          this.ruleForm = resp.dataObj
        } else {
          this.ruleForm = {}
          let formDataCurrent = {}
          for (var name in this.formData) {
            formDataCurrent[name] = this.formData[name]
          }
          for (var name in formDataCurrent) {
            if (formDataCurrent[name] || formDataCurrent[name] === '' || formDataCurrent[name] === 0) {
              if (typeof formDataCurrent[name] === 'number') {
                this.ruleForm[name] = formDataCurrent[name]
              } else if (Date.parse(formDataCurrent[name]).toString() !== 'NaN') {
                this.ruleForm[name] = formDataCurrent[name]
              } else if (formDataCurrent[name].indexOf(',') === -1 && parseFloat(formDataCurrent[name]).toString() !== 'NaN') {
                this.ruleForm[name] = parseFloat(formDataCurrent[name])
              } else if (formDataCurrent[name].indexOf(',') !== -1) {
                this.ruleForm[name] = formDataCurrent[name]
              } else {
                this.ruleForm[name] = formDataCurrent[name]
              }
            }
          }
        }
        this.loadSuccess = true
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/FormUiSimpleTableFormDialog.vue